const TYPE_EXCEL = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const downloadExcel = (base64, functionLoading, nameDocument = 'document') => {
  window.fetch(`data:${TYPE_EXCEL};base64,${base64}`)
    .then((res) => res.blob())
    .then((blob) => {
      functionLoading();
      const file = new window.File([blob], `${nameDocument}.xlsx`, {
        TYPE_EXCEL,
      });
      const fileURL = URL.createObjectURL(file);
      const link = document.createElement('a');
      link.href = fileURL;
      link.setAttribute('download', `${nameDocument}.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
};
